import { z } from 'zod';

import { TextItem } from './common';

export const DistractingActivity = TextItem;
export type DistractingActivity = z.infer<typeof DistractingActivity>;

export const DistractingActivities = z.array(DistractingActivity).default([]);
export type DistractingActivities = z.infer<typeof DistractingActivities>;
